import React, { useState } from 'react';
import { Globe, Shield, Bell, Moon, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { useApp } from '../context/AppContext';
export function SettingsScreen() {
  const {
    navigate
  } = useNavigation();
  const {
    isDarkMode,
    toggleDarkMode
  } = useApp();
  const [pushEnabled, setPushEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(false);
  const Toggle = ({
    enabled,
    onChange
  }: {
    enabled: boolean;
    onChange: () => void;
  }) => <button onClick={onChange} className={`w-12 h-6 rounded-full transition-colors relative ${enabled ? 'bg-primary' : 'bg-gray-200'}`} data-id="element-1338">
      <div className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-transform shadow-sm ${enabled ? 'translate-x-6' : 'translate-x-0.5'}`} data-id="element-1339" />
    </button>;
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50" data-id="element-1340">
      <Header title="Settings" data-id="element-1341" />

      <div className="space-y-6 p-4" data-id="element-1342">
        <section data-id="element-1343">
          <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 ml-2" data-id="element-1344">
            Preferences
          </h3>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-50 overflow-hidden" data-id="element-1345">
            <button className="w-full flex items-center justify-between p-4 border-b border-gray-50 active:bg-gray-50 transition-colors" data-id="element-1346">
              <div className="flex items-center gap-3" data-id="element-1347">
                <Globe className="w-5 h-5 text-gray-400" data-id="element-1348" />
                <span className="font-medium text-gray-700" data-id="element-1349">Language</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1350">
                <span className="text-sm text-gray-500" data-id="element-1351">English (US)</span>
                <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-1352" />
              </div>
            </button>
            <button className="w-full flex items-center justify-between p-4 border-b border-gray-50 active:bg-gray-50 transition-colors" data-id="element-1353">
              <div className="flex items-center gap-3" data-id="element-1354">
                <span className="w-5 h-5 text-gray-400 font-bold flex items-center justify-center" data-id="element-1355">
                  ₦
                </span>
                <span className="font-medium text-gray-700" data-id="element-1356">Currency</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1357">
                <span className="text-sm text-gray-500" data-id="element-1358">NGN (₦)</span>
                <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-1359" />
              </div>
            </button>
            <div className="w-full flex items-center justify-between p-4" data-id="element-1360">
              <div className="flex items-center gap-3" data-id="element-1361">
                <Moon className="w-5 h-5 text-gray-400" data-id="element-1362" />
                <span className="font-medium text-gray-700" data-id="element-1363">Dark Mode</span>
              </div>
              <Toggle enabled={isDarkMode} onChange={toggleDarkMode} data-id="element-1364" />
            </div>
          </div>
        </section>

        <section data-id="element-1365">
          <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 ml-2" data-id="element-1366">
            Notifications
          </h3>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-50 overflow-hidden" data-id="element-1367">
            <div className="w-full flex items-center justify-between p-4 border-b border-gray-50" data-id="element-1368">
              <div className="flex items-center gap-3" data-id="element-1369">
                <Bell className="w-5 h-5 text-gray-400" data-id="element-1370" />
                <span className="font-medium text-gray-700" data-id="element-1371">
                  Push Notifications
                </span>
              </div>
              <Toggle enabled={pushEnabled} onChange={() => setPushEnabled(!pushEnabled)} data-id="element-1372" />
            </div>
            <div className="w-full flex items-center justify-between p-4" data-id="element-1373">
              <div className="flex items-center gap-3" data-id="element-1374">
                <span className="w-5 h-5 text-gray-400 flex items-center justify-center" data-id="element-1375">
                  @
                </span>
                <span className="font-medium text-gray-700" data-id="element-1376">
                  Email Notifications
                </span>
              </div>
              <Toggle enabled={emailEnabled} onChange={() => setEmailEnabled(!emailEnabled)} data-id="element-1377" />
            </div>
          </div>
        </section>

        <section data-id="element-1378">
          <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 ml-2" data-id="element-1379">
            Security
          </h3>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-50 overflow-hidden" data-id="element-1380">
            <button onClick={() => navigate(Screen.CHANGE_PASSWORD)} className="w-full flex items-center justify-between p-4 border-b border-gray-50 active:bg-gray-50 transition-colors" data-id="element-1381">
              <div className="flex items-center gap-3" data-id="element-1382">
                <Shield className="w-5 h-5 text-gray-400" data-id="element-1383" />
                <span className="font-medium text-gray-700" data-id="element-1384">
                  Change Password
                </span>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-1385" />
            </button>
            <button onClick={() => navigate(Screen.TWO_FACTOR)} className="w-full flex items-center justify-between p-4 active:bg-gray-50 transition-colors" data-id="element-1386">
              <div className="flex items-center gap-3" data-id="element-1387">
                <span className="w-5 h-5 text-gray-400 flex items-center justify-center" data-id="element-1388">
                  📱
                </span>
                <span className="font-medium text-gray-700" data-id="element-1389">
                  Two-Factor Authentication
                </span>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-1390" />
            </button>
          </div>
        </section>
      </div>
    </motion.div>;
}